export const siteSettings = {
  name: "Corea HQ",
  link: "https://coreahq.live",
  email: "support@coreahq.live",
  appLink: "https://app.coreahq.live",
};
